import React, { useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import {
  InformationPageContentWrapper,
  InformationPageTitleText,
  InformationPagePageMainText,
  InformationPageContainer,
} from './styles/informationPages.styles';
import { useTypedTranslate } from '../../translations/useTypedTranslate';
import { SuccessPageTimeSpeedIcon } from './styles/InformationPageIcons.styles';
import { useAssistanceFormContext } from '../../common/contexts/AssistanceForm/useAssistanceFormContext';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../common/constants/defaultStaticUrls';

export const SuccessPage: React.FC = () => {
  const { t } = useTypedTranslate();
  const navigate = useNavigate();
  const { clearCachedFormData, reportId } = useAssistanceFormContext();

  useEffect(() => {
    if (!reportId) {
      return navigate(ROUTES.HOME);
    }

    clearCachedFormData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <InformationPageContainer>
      <InformationPageContentWrapper>
        <SuccessPageTimeSpeedIcon />
        <InformationPageTitleText>
          {t('YOUR_REPORT_NR')} {reportId} {t('HAS_BEEN_RECEIVED_FOR_PROCESSING')}
        </InformationPageTitleText>
        <InformationPagePageMainText>
          <ReactMarkdown>{t('WE_WILL_CONTACT_WITH_YOU_WITHIN_A_FEW_MINUTES')}</ReactMarkdown>
        </InformationPagePageMainText>
      </InformationPageContentWrapper>
    </InformationPageContainer>
  );
};
